import React from 'react';
const ProductVideos = ({ title, internalVideo, vimeo, youtube }) => {

  const renderVideo = (url) => {
    {
      return (
        <div className="columns small-12 medium-6 large-4 product-about__documents--videos" >
          <video controls preload="none" >
            <source src={url} />
          </video>
        </div>
      )
    }
  }
  const renderIframe = (url,index) => {
    {
      return (
        <div className="columns small-12 medium-6 large-4 product-about__documents--videos" key={index} >
          <iframe  src={url} allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
        </div>
      )
    }
  }
  const internal = internalVideo;
  const vimeoLinks = JSON.parse(vimeo);
  const youtubeLinks = JSON.parse(youtube);
  const setSelected = (event) => {
    event.currentTarget.parentNode.classList.toggle('expanded');
  };
  return (
    <div className="small-12 large-12 columns product-about">
      <div className="product-about__accordion">
        <div
          className="product-about__heading-container">
          <div className="product-about__heading" onClick={(e) => setSelected(e)}>
            <h6 className="product-about__title">{title}</h6>
            <div className="product-about__icon"></div>
          </div>
          <div className="product-about__content">
            <div className="product-about__documents">
              <div className="row">
                
                  {internal &&
                    (
                      renderVideo(internal)
                    )}
                  {vimeoLinks &&
                    vimeoLinks.length > 0 &&
                    (
                      vimeoLinks.map((video, indexVimeo) => (
                        video != null &&
                         renderIframe("https://player.vimeo.com/video/" + video, indexVimeo)
                       
                      )))}
                  {youtubeLinks &&
                    youtubeLinks.length > 0 &&
                    youtubeLinks.map((video, indexYoutube) => (
                      video != null &&
                       renderIframe("https://www.youtube.com/embed/" + video, indexYoutube)                    
                    ))}
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductVideos;
